import React, { useContext } from 'react';
import { string } from 'prop-types';
import { Route, Routes } from '@thd-olt-component-react/router';
import { AppContext, Generic4xx } from '@thd-nucleus/app-render';
import { Error } from './pages';
import './styles/app.scss';
import { getRoutes } from './routes';

export const App = ({ recaptchaKey, recaptchaV3Key }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent);
  return (
    <Routes>
      <Route
        exact
        path={routes.exerciseMyPrivacyRights.path}
        element={<routes.exerciseMyPrivacyRights.component recaptchaKey={recaptchaKey} />}
      />
      <Route
        path={routes.californiaPrivacyRights.path}
        element={<routes.californiaPrivacyRights.component />}
      />
      <Route
        path={routes.privacySecurity.path}
        element={<routes.privacySecurity.component />}
      />
      <Route
        exact
        path={routes.exerciseMyPrivacyRightsOld.path}
        element={<routes.exerciseMyPrivacyRightsOld.component recaptchaKey={recaptchaKey} />}
      />
      <Route
        path={routes.californiaPrivacyRightsOld.path}
        element={<routes.californiaPrivacyRightsOld.component />}
      />
      <Route
        path={routes.myPreferenceCenter.path}
        element={<routes.myPreferenceCenter.component recaptchaV3Key={recaptchaV3Key} />}
      />
      <Route
        path={routes.privacyOverview.path}
        element={<routes.privacyOverview.component />}
      />
      <Route
        path={routes.privacyStatement.path}
        element={<routes.privacyStatement.component />}
      />
      <Route
        path={routes.privacyReports.path}
        element={<routes.privacyReports.component />}
      />
      <Route
        path={routes.privacyHome.path}
        element={<routes.privacyHome.component />}
      />
      <Route
        path={routes.fraudCenter.path}
        element={<routes.fraudCenter.component />}
      />
      <Route
        path={routes.supplyChainPrivacyPolicy.path}
        element={<routes.supplyChainPrivacyPolicy.component />}
      />
      <Route
        path="/error"
        element={<Error />}
      />
      <Route
        element={<Generic4xx />}
      />
    </Routes>
  );
};

App.propTypes = {
  recaptchaKey: string,
  recaptchaV3Key: string
};

App.defaultProps = {
  recaptchaKey: '',
  recaptchaV3Key: ''
};
